var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pb-40 bg-slate-300",
      style: { minHeight: "calc(100vh - 4.5rem - 0.5rem)" }
    },
    [
      _c("div", { staticClass: "analytics-sticky pt-4 px-6" }, [
        _c(
          "div",
          { staticClass: "flex items-center justify-between" },
          [_c("BlTextTitle3", { attrs: { text: "Acquisition Comparison" } })],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fixed bottom-0 right-0 z-40 p-6" }, [
        _c(
          "button",
          {
            staticClass:
              "h-25 w-25 flex flex-col items-center justify-center gap-1 bg-light-purple hover:bg-dark-purple-200 rounded-full border-2 border-pure-white shadow-lg outline-none",
            class: { "cursor-wait": _vm.createLoading },
            attrs: {
              title: "New comparison graph",
              disabled: _vm.createLoading
            },
            on: { click: _vm.onCreate }
          },
          [
            _c("BlIcon", { attrs: { icon: "plus", color: "secondary" } }),
            _vm._v(" "),
            _c("BlTextSubtitle3", {
              staticClass: "text-pure-white",
              attrs: { text: "New" }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.fetchLoading
        ? _c("div", { staticClass: "h-100 grid place-items-center" }, [
            _c("div", { staticClass: "blum-loader" })
          ])
        : !_vm.comparisonGraphs.length
        ? _c("div", { staticClass: "h-100 grid place-items-center" }, [
            _c(
              "div",
              [_c("BlTextBody2", { attrs: { text: "Data not found." } })],
              1
            )
          ])
        : _c(
            "draggable",
            {
              staticClass: "py-4 px-6 flex flex-col gap-6",
              attrs: { handle: ".handle_comparison" },
              on: {
                update: function($event) {
                  $event.preventDefault()
                  return _vm.onMove($event)
                }
              }
            },
            _vm._l(_vm.comparisonGraphs, function(comparison) {
              return _c("AcquisitionGraph", {
                key: comparison.id,
                attrs: { id: comparison.id, comparisonGraph: comparison }
              })
            }),
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-799a152d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-799a152d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/AcquisitionComparison.vue
// module id = null
// module chunks = 